import { InfoRow } from "@components/info-row";
import { AdmPlan } from "@custom-types/base-types";
import { attachedTokenPlansSelector } from "@store/plans/plans-selector";
import { useAppSelector } from "@store/store-helper";
import { CREDITS_DISPLAY_NAME } from "@utils/limit-data-display";
import {
  formatTokenPlanPeriod,
  formatTokenPlanUsage,
} from "@utils/token-plan-utils";
import { capitalize } from "es-toolkit/string";

interface Props {
  /** The ID of the plan to show the tokens of */
  planId: AdmPlan["id"];
}

/**
 * Shows one row for every year of tokens a plan includes, as those are granted by separate token
 * plans that the plans table does not list on their own. Nothing is shown for a plan without them.
 */
export function PlanTokenRows({ planId }: Props): React.JSX.Element | null {
  const tokenPlans = useAppSelector(attachedTokenPlansSelector(planId));

  if (!tokenPlans.length) {
    return null;
  }

  return (
    <>
      {tokenPlans.map((tokenPlan) => (
        <InfoRow
          key={tokenPlan.id}
          label={`${capitalize(
            CREDITS_DISPLAY_NAME
          )} ${formatTokenPlanPeriod(tokenPlan)}`}
          info={formatTokenPlanUsage(tokenPlan)}
          tooltip={tokenPlan.id}
        />
      ))}
    </>
  );
}
